interface ApiErrorShape {
  data?: {
    messages?: unknown;
    message?: unknown;
  };
}

const firstString = (value: unknown): string | null => {
  if (typeof value === "string" && value.trim().length > 0) return value;

  if (Array.isArray(value)) {
    const found: unknown = value.find(
      (item: unknown): boolean =>
        typeof item === "string" && item.trim().length > 0
    );

    return typeof found === "string" ? found : null;
  }

  return null;
};

export const apiErrorMessage = (error: unknown): string | null => {
  const data: ApiErrorShape["data"] = (error as ApiErrorShape)?.data;

  if (!data) return null;

  return firstString(data.messages) ?? firstString(data.message);
};
